import { render, staticRenderFns } from "./DropProduct.vue?vue&type=template&id=58fb5e9a"
import script from "./DropProduct.vue?vue&type=script&lang=ts"
export * from "./DropProduct.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports